// SAMPLE_WTT — the 11-row Day Out With Thomas timetable from the v5
// prototype (lines ~384–397). Used by ImportWttModal's "Load sample WTT"
// button for QA, training, and demo flow.

export const SAMPLE_WTT = [
  'time,service,loco,from,to,capacity',
  '09:30,Service 1,Thomas (No.1),Pickering,Newbridge,320',
  '10:05,Service 2,Thomas (No.1),Pickering,Newbridge,320',
  '10:40,Service 3,Thomas (No.1),Pickering,Newbridge,320',
  '11:15,Service 4,Thomas (No.1),Pickering,Newbridge,320',
  '11:50,Service 5,Thomas (No.1),Pickering,Newbridge,320',
  '12:25,Service 6,Thomas (No.1),Pickering,Newbridge,320',
  '13:00,Service 7,Thomas (No.1),Pickering,Newbridge,320',
  '13:35,Service 8,Thomas (No.1),Pickering,Newbridge,320',
  '14:10,Service 9,Thomas (No.1),Pickering,Newbridge,320',
  '14:45,Service 10,Thomas (No.1),Pickering,Newbridge,320',
  '15:20,Service 11,Thomas (No.1),Pickering,Newbridge,320'
].join('\n')
